import {useSyncExternalStore} from 'react'

function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query)
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    () => window.matchMedia(query).matches,
    () => false
  )
}

/** Same 768px cutoff as the sidebar and app layout. */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)')
}
